<template>
  <a-select
    :value="value"
    :show-search="true"
    :placeholder="placeholder"
    :filter-option="filterOption"
    allowClear
    style="width: 100%"
    @change="onChange"
  >
    <a-select-option v-for="item in dataItems" :key="item.id" :value="item.id" :item="item">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
import { orderTypeOption } from "@/api/option";

export default {
  props: ["value", "disabled", "placeholder"],
  model: { prop: "value", event: "change" },
  data() {
    return {
      dataItems: [],
      queryLoading: false,
    };
  },
  methods: {
    filterOption(input, option) {
      const item = option.data.attrs.item;
      return item.name.toLowerCase().indexOf(input.toLowerCase()) !== -1;
    },
    onChange(value) {
      this.$emit("change", value);
    },
  },
  mounted() {
    this.queryLoading = true;
    orderTypeOption({ page_size: 999999 })
      .then((data) => (this.dataItems = data.results))
      .finally(() => (this.queryLoading = false));
  },
};
</script>

<style scoped></style>
